const lineColors = {
  decrease: 'rgba(229, 89, 78, 1)',
  increase: 'rgba(48, 191, 163, 1)',
};

const chartColors = {
  decrease: 'rgba(229, 89, 78, 0.1)',
  increase: 'rgba(48, 191, 163, 0.1)',
};

export const decrease = {
  bottomColor: chartColors.decrease,
  lineColor: lineColors.decrease,
  topColor: chartColors.decrease,
};

export const increase = {
  bottomColor: chartColors.increase,
  lineColor: lineColors.increase,
  topColor: chartColors.increase,
};
